module.exports = __webpack_public_path__ + "img/grooming-menu.342bc89f.png";